export default {
    login: {
        title: 'Accedi al tuo account',
        subtitle: 'Inserisci le tue credenziali per accedere al pannello amministrativo',
        emailLabel: 'Email',
        emailPlaceholder: 'nome@azienda.com',
        passwordLabel: 'Password',
        passwordPlaceholder: '••••••••',
        forgotPassword: 'Password dimenticata?',
        submitButton: 'Accedi',
        noAccount: 'Non hai un account?',
        contactAdmin: 'Contatta l\'amministratore',
        credentialsTitle: 'Credenziali Demo',
        errorInvalidCredentials: 'Credenziali non valide',
        errorLogin: 'Errore durante il login',
    },
    resetPassword: {
        title: 'Reimposta password',
        subtitle: 'Inserisci la tua email e ti invieremo un link per reimpostare la password',
        emailLabel: 'Email',
        emailPlaceholder: 'nome@azienda.com',
        submitButton: 'Invia link di reset',
        backToLogin: 'Torna al login',
        successTitle: 'Email inviata!',
        successMessage: 'Ti abbiamo inviato un link per reimpostare la password all\'indirizzo',
        successInstructions: 'Controlla la tua casella di posta.',
        backToLoginButton: 'Torna al Login',
        sendAnotherEmail: 'Invia un\'altra email',
        errorRequest: 'Errore nella richiesta di reset password. Riprova.',
        errorResend: 'Errore nell\'invio dell\'email. Riprova.',
        resendSuccess: 'Email inviata con successo!',
    },
    newPassword: {
        title: 'Imposta Nuova Password',
        subtitle: 'Inserisci la tua nuova password qui sotto',
        verifying: 'Verifica token di reset in corso...',
        noToken: 'Token di reset non fornito',
        invalidToken: 'Token di reset non valido o scaduto',
        errorTitle: 'Token di Reset Non Valido',
        backToLogin: 'Torna al Login',
        passwordLabel: 'Nuova Password',
        passwordPlaceholder: 'Inserisci nuova password (minimo 8 caratteri)',
        passwordConfirmLabel: 'Conferma Nuova Password',
        passwordConfirmPlaceholder: 'Reinserisci la nuova password',
        passwordTooShort: 'La password deve essere di almeno 8 caratteri',
        passwordsDoNotMatch: 'Le password non corrispondono',
        submitButton: 'Reimposta Password',
        resetError: 'Errore durante il reset della password. Riprova.',
        successTitle: 'Password Reimpostata!',
        successMessage: 'La tua password è stata reimpostata con successo. Ora puoi accedere con la tua nuova password.',
        redirecting: 'Reindirizzamento al login...',
    },
    verifyInvitation: {
        title: 'Configura la tua password',
        titleExistingUser: 'Accetta Invito',
        subtitle: 'Sei stato invitato a unirti a {{companyName}}. Configura la tua password per completare la registrazione.',
        email: 'Email: {{email}}',
        verifying: 'Verifica invito in corso...',
        noToken: 'Token di invito non fornito',
        invalidToken: 'Token di invito non valido o scaduto',
        differentUser: 'Questo invito è per un altro utente. Effettua il logout e usa l\'account corretto.',
        errorTitle: 'Invito non valido',
        goToLogin: 'Vai al Login',
        goToHome: 'Vai alla Home',
        passwordLabel: 'Password',
        passwordPlaceholder: 'Inserisci password (minimo 8 caratteri)',
        passwordConfirmLabel: 'Conferma Password',
        passwordConfirmPlaceholder: 'Reinserisci la password',
        passwordTooShort: 'La password deve essere di almeno 8 caratteri',
        passwordsDoNotMatch: 'Le password non corrispondono',
        submitButton: 'Configura Password',
        setupError: 'Errore durante la configurazione della password',
        successTitle: 'Password configurata!',
        successMessage: 'La tua password è stata configurata con successo. Ora puoi accedere.',
        redirecting: 'Reindirizzamento al login...',
        existingUserMessage: 'Hai già un account. Clicca qui sotto per accettare l\'invito e unirti a questa azienda.',
        acceptButton: 'Accetta Invito',
        acceptError: 'Errore durante l\'accettazione dell\'invito',
    },
};

